
import {switchMap} from 'rxjs/operators';
//https://blogs.msdn.microsoft.com/premier_developer/2017/04/26/using-adal-with-angular2/
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { } from 'adal';
import { Observable,    Subscriber ,  of } from 'rxjs';
import { SettingsProvider } from '../services/global/settings-provider.service';
import { GlobalService } from '../services/global/global.service';
import { UserModel } from '../models/user.model';
//import 'expose-loader?AuthenticationContext!../../../../../node_modules/adal-angular/lib/adal.js'; 
//let createAuthContextFn: adal.AuthenticationContextStatic = AuthenticationContext; 
/*

//write a triple slash to import the typings
// <reference path="../../../../../node_modules/@types/adal/index.d.ts" />
//import adal.js and expose it as AuthenticationContext using the expose loader
import 'expose?AuthenticationContext!../../../../../node_modules/adal-angular/lib/adal.js';
//declare a variable of type AuthenticationContextStatic and assign it value of AuthenticationContext
let createAuthContextFn: adal.AuthenticationContextStatic = AuthenticationContext; 
https://github.com/HNeukermans/adal-ts-consumer
*/
export enum HttpMethod {
    get = 1,
    post = 2,
    put = 3,
    delete = 4
}

@Injectable()
export class AdalService {
    private _config: adal.Config;
    private _context: adal.AuthenticationContext;
    private _subscription: string = "";
    private _resource: string = "";
    private _user: adal.User;
    private _token: string = "";

    constructor(private http:HttpClient,
                private globals: GlobalService,
                public settings:SettingsProvider) {
        console.log("AUTH: AdalSvc-Constructor");
    }

    loadConfig() {
        if (this.settings.configuration != undefined && this._config == undefined) {
            this._config =  this.settings.configuration.azurePortalConfig;
            this._subscription = this.settings.configuration.azurePortalConfig.subscription;
            this._resource = this.settings.configuration.azurePortalConfig.clientId;
            this._context = new AuthenticationContext(this._config);
        }
        // console.log("AUTH: AdalSvc-LoadConfig");
    }

    get config(): adal.Config {
        return this._config;
    }

    get context(): adal.AuthenticationContext {
        this.loadConfig();
        return this._context;
    }

    get isLogged(): boolean {
        this.loadConfig();
        this._user = this._context.getCachedUser();
        this._token = this._context.getCachedToken(this._config.clientId);
        if (this._user != undefined)
            if ( this._user.userName != this.globals.user.username ) {
                var user: UserModel = new UserModel();
                user.name = this._user.profile.name;
                user.given_name = this._user.profile.given_name;
                user.family_name = this._user.profile.family_name;
                user.username = this._user.userName;
                user.ipaddr = this._user.profile.ipaddr;
                this.globals.SetUser(user);
            }
        // console.log("AUTH: AdalSvc-isLogged " + (!!this._user && !!this._token));
        //console.log(this._token);
        return !!this._user && !!this._token;
    }

    get userInfo(): adal.User {
        return this._user;
    }

    get subscription(): string {
        return this._subscription;
    }

    get resourceEndpoint(): string {
        return this._resource;
    }

    public acquireToken(resource:string):Observable<any>{
        var saveToken
        if (resource == "")
            return of("");
        else
            return new Observable<any>((subscriber: Subscriber<any>) => 
                this._context.acquireToken(resource, (message: string, token: string)=>{
                    if (token != this._token)
                        console.log('Token acquired: ' + token);
                    subscriber.next(token);
                })
            );
    }

    public logout() {
        this._context.logOut();
    }

    public get(url:string, params?: HttpParams):Observable<any>{

        return this.acquireToken(this._resource).pipe(
            switchMap(token => 
                this.http.get(url, { 
                    params: params,
                headers:{   "Authorization": "Bearer " + token,
                            "withCredentials": "true",      
                            "Content-Type": "application/json; charset=utf-8",
                            "Ocp-Apim-Subscription-Key": this._subscription
        
          }})));
    }

    public post(url:string, data:any):Observable<any>{
        return this.acquireToken(this._resource).pipe(
            switchMap(token => 
                this.http.post(url, data, { 
                headers:{   "Authorization": "Bearer " + token,
                            "withCredentials": "true",      
                            "Content-Type": "application/json; charset=utf-8",
                            "Ocp-Apim-Subscription-Key": this._subscription
        }})));
    }

    public getAttachment(url:string, params?: HttpParams):Observable<any>{
        if (!this._subscription)
            this._subscription = this.settings.configuration.azurePortalConfig.subscription;
        return this.acquireToken(this._resource).pipe(
            switchMap(token => 
                this.http.get(url, { 
                    params: params,
                    responseType: "blob",
                headers:{   "Authorization": "Bearer " + token,
                            "withCredentials": "true",
                            "Ocp-Apim-Subscription-Key": this._subscription
        
          }})));
    }

    public getLoggedInUserProfilePhoto(): Observable<any> {
        return this.acquireToken("https://graph.microsoft.com").pipe(
            switchMap((token) =>
            this.http.get("https://graph.microsoft.com/v1.0/me/photo/$value", {
                responseType: "blob",
                headers: {
                    Authorization: "Bearer " + token,
                    withCredentials: "true",
                    "Ocp-Apim-Subscription-Key": this._subscription
                },
            })
            )
        );
    }

    public get getAuthHeaders(): HttpHeaders {
        var headers: HttpHeaders;
		headers = new HttpHeaders();
        headers = headers.set('Authorization', 'Bearer ' + this._token);
        headers = headers.set('withCredentials', 'true');
        headers = headers.set('Content-Type', 'application/json; charset=utf-8');
		headers = headers.set('Ocp-Apim-Subscription-Key', this._subscription);
        return headers;
    }

    public get getPictureAuthHeaders(): HttpHeaders {
        var headers: HttpHeaders;
		headers = new HttpHeaders();
        headers = headers.set('Authorization', 'Bearer ' + this._token);
        headers = headers.set('withCredentials', 'true');
		headers = headers.set('Ocp-Apim-Subscription-Key', this._subscription);
        return headers;
    }

    public addBlobAuthHeaders(headers: HttpHeaders): HttpHeaders {
        headers = headers.append('Authorization', 'Bearer ' + this._token);
        headers = headers.append('withCredentials', 'true');        
		headers = headers.append('Ocp-Apim-Subscription-Key', this._subscription);
        return headers;
    }

}
